import type { Article, Wallpaper } from './types'

export const ARTICLES: Article[] = [
  {
    id: 'aadi-month',
    slug: 'why-aadi-month-is-special',
    titleTa: 'ஆடி மாதம் ஏன் சிறப்பு?',
    titleEn: 'Why Aadi Month Is Special',
    excerptTa: 'ஆடி மாதத்தின் ஆன்மீக முக்கியத்துவம், அம்மன் வழிபாடு மற்றும் ஆடி வெள்ளி பற்றிய எளிய அறிமுகம்.',
    bodyTa: `ஆடி மாதம் தமிழ் நாட்காட்டியில் பக்தி நிறைந்த காலமாகக் கருதப்படுகிறது. பல குடும்பங்களில் அம்மன் வழிபாடு, ஆடி வெள்ளி மற்றும் கோயில் விழாக்கள் இக்காலத்தில் சிறப்பாக நடைபெறும்.

**ஆடி வெள்ளி**
ஆடி மாதத்தின் வெள்ளிக்கிழமைகளில் அம்மன் கோயில்களுக்குச் செல்வது பாரம்பரியம். சில இடங்களில் சிறப்பு அலங்காரம், பொங்கல் மற்றும் குழுப் பாடல்கள் உண்டு.

**குடும்ப வேறுபாடுகள்**
பழக்க வழக்கங்கள் ஊருக்கு ஊர், குடும்பத்திற்குக் குடும்பம் மாறலாம். இங்கே கொடுக்கப்படும் தகவல்கள் பொதுவான அறிமுகம் மட்டுமே.

**பக்தி அணுகுமுறை**
ஆடி காலத்தை மன அமைதி, நன்றி மற்றும் குடும்ப ஒற்றுமைக்கான நேரமாகப் பார்க்கலாம். எந்த ஆரோக்கியம் / செல்வ உத்தரவாதத்தையும் இத்தளம் அளிப்பதில்லை.`,
    relatedContentIds: ['aigiri-nandini', 'amman-potri-108'],
    youtubeVideoId: 'oNPyij7UWXA',
    keywords: ['ஆடி', 'aadi', 'ஆடி வெள்ளி', 'amman'],
    seoDescription: 'ஆடி மாதத்தின் சிறப்பு — தெய்வீக ஓசை ஆன்மீக அறிவு.',
  },
  {
    id: 'arunagirinathar',
    slug: 'story-of-arunagirinathar',
    titleTa: 'அருணகிரிநாதர் கதை',
    titleEn: 'Story of Arunagirinathar',
    excerptTa: 'திருப்புகழ் மற்றும் கந்தர் அனுபூதி இயற்றிய அருணகிரிநாதரின் வாழ்க்கைச் சுருக்கம்.',
    bodyTa: `அருணகிரிநாதர் தமிழ்ப் பக்தி இலக்கியத்தில் முருகன் பாரம்பரியத்தின் முக்கிய கவிஞர். அவரது **திருப்புகழ்** மற்றும் **கந்தர் அனுபூதி** இன்றுவரை பாடப்படுகின்றன.

**சுருக்கமான வாழ்க்கை**
பாரம்பரியக் கதையின்படி, வாழ்க்கையின் திருப்புமுனையில் முருகனின் அருளைப் பெற்ற அவர், திருவண்ணாமலையை மையமாகக் கொண்டு பக்திப் பாடல்களை இயற்றினார்.

**இசை நயம்**
திருப்புகழ் பாடல்கள் தாளம் மற்றும் சந்த அமைப்பில் சிறப்பு வாய்ந்தவை. பல பாடல்கள் கோயில் மற்றும் வீட்டு வழிபாட்டில் பயன்படுகின்றன.

**இந்தத் தளத்தில்**
«உருவாய் அருவாய்» மற்றும் «முத்தைத் தரு» போன்ற பக்கங்களில் வரிகளுடன் எளிய பொருள் காணலாம்.`,
    relatedContentIds: ['uruvai-aruvai', 'muthai-tharu'],
    youtubeVideoId: 'Gf1bgGBq6c4',
    keywords: ['அருணகிரிநாதர்', 'arunagirinathar', 'thiruppugazh', 'murugan'],
    seoDescription: 'அருணகிரிநாதர் கதை — திருப்புகழ் பாரம்பரியம்.',
  },
  {
    id: 'kanda-sashti',
    slug: 'meaning-of-kanda-sashti',
    titleTa: 'கந்த சஷ்டியின் பொருள்',
    titleEn: 'Meaning of Kanda Sashti',
    excerptTa: 'கந்த சஷ்டி விரதம், சூரசம்ஹாரம் மற்றும் முருகன் வழிபாட்டின் எளிய விளக்கம்.',
    bodyTa: `கந்த சஷ்டி முருகனின் வெற்றியையும் அருளையும் கொண்டாடும் விரதக் காலம். பல பக்தர்கள் ஆறு நாட்கள் விரதமிருந்து சூரசம்ஹாரத்தன்று முடிப்பார்கள்.

**சூரசம்ஹாரம்**
தீய சக்திகளை வெல்லும் முருகனின் வெற்றியைக் குறிக்கும் நிகழ்வு பல கோயில்களில் நாடக / உற்சவ வடிவில் நடைபெறும்.

**வீட்டு வழிபாடு**
ஸ்கந்த சஷ்டி கவசம், திருப்புகழ் மற்றும் எளிய முருகன் ஸ்துதிகளைப் பாடுவது பொதுவான வழக்கம்.

**குறிப்பு**
விரத முறைகள் பிராந்தியத்துக்கு ஏற்ப மாறும். ஆரோக்கியம் குறித்து மருத்துவ ஆலோசனையே முதன்மை.`,
    relatedContentIds: ['uruvai-aruvai', 'muthai-tharu'],
    youtubeVideoId: '5g85Zrvj9f4',
    keywords: ['கந்த சஷ்டி', 'kanda sashti', 'murugan', 'skanda'],
    seoDescription: 'கந்த சஷ்டியின் பொருள் — தெய்வீக ஓசை.',
  },
]

export const WALLPAPERS: Wallpaper[] = [
  {
    id: 'wp-shiva-1',
    titleTa: 'சிவ லிங்கம் — அமைதி',
    titleEn: 'Shiva Lingam Peace',
    deity: 'shiva',
    imageUrl: '/wallpapers/wp-shiva-1.jpg',
    previewColor: '#3D1F28',
    accentColor: '#C9A227',
    relatedContentId: 'lingashtakam',
  },
  {
    id: 'wp-shiva-2',
    titleTa: 'ஓம் நமசிவாய',
    titleEn: 'Om Namah Shivaya',
    deity: 'shiva',
    imageUrl: '/wallpapers/wp-shiva-2.jpg',
    previewColor: '#2A1810',
    accentColor: '#E8B86D',
    relatedContentId: 'lingashtakam',
  },
  {
    id: 'wp-amman-1',
    titleTa: 'அம்மன் அருள்',
    titleEn: 'Amman Grace',
    deity: 'amman',
    imageUrl: '/wallpapers/wp-amman-1.jpg',
    previewColor: '#4A1520',
    accentColor: '#D4A017',
    relatedContentId: 'aigiri-nandini',
  },
  {
    id: 'wp-ayyappan-1',
    titleTa: 'சரணம் அய்யப்பா',
    titleEn: 'Saranam Ayyappa',
    deity: 'ayyappan',
    imageUrl: '/wallpapers/wp-ayyappan-1.jpg',
    previewColor: '#1A2F1A',
    accentColor: '#C9A227',
    relatedContentId: 'ayyappan-song',
  },
  {
    id: 'wp-lakshmi-1',
    titleTa: 'மகாலக்ஷ்மி',
    titleEn: 'Mahalakshmi',
    deity: 'lakshmi',
    imageUrl: '/wallpapers/wp-lakshmi-1.jpg',
    previewColor: '#3A1A28',
    accentColor: '#F0C75E',
    relatedContentId: 'mahalakshmi-song',
  },
  {
    id: 'wp-murugan-1',
    titleTa: 'முருகன் வேல்',
    titleEn: 'Murugan Vel',
    deity: 'murugan',
    imageUrl: '/wallpapers/wp-murugan-1.jpg',
    previewColor: '#1E2440',
    accentColor: '#C9A227',
    relatedContentId: 'uruvai-aruvai',
  },
]

export const SEASONAL = {
  id: 'aadi-friday',
  titleTa: 'ஆடி வெள்ளி சிறப்பு',
  titleEn: 'Aadi Friday Special',
  descriptionTa:
    'ஆடி மாத வெள்ளிக்கிழமைகளில் அம்மன் ஸ்துதிகளையும் பொற்றிகளையும் கேளுங்கள். பக்திக்கு ஏற்ற பாடல்கள் இங்கே.',
  ctaLabelTa: 'அம்மன் ஸ்துதிகளைப் பாருங்கள்',
  ctaPath: '/deities/amman',
  contentIds: ['aigiri-nandini', 'amman-potri-108'],
}

export function getArticleBySlug(slug: string) {
  return ARTICLES.find((a) => a.slug === slug)
}

export function getWallpaperById(id: string) {
  return WALLPAPERS.find((w) => w.id === id)
}

export function searchArticles(query: string) {
  const q = query.trim().toLowerCase()
  if (!q) return []
  return ARTICLES.filter((a) =>
    [a.titleTa, a.titleEn, a.excerptTa, a.bodyTa, ...a.keywords].join(' ').toLowerCase().includes(q),
  )
}
